<template>
  <div class="featured">
    <div class="subtitle">As featured in...</div>
    <div class="img-container">
      <div class="img rouler">
        <img
          src="~/assets/images/trust-marker-logos/rouleur.png"
          alt="rouler image"
          width="300"
          height="60"
        />
      </div>
      <div class="img cycling-weekly">
        <img
          src="~/assets/images/trust-marker-logos/cycling-weekly.png"
          alt="weekly image"
          width="300"
          height="60"
        />
      </div>
      <div class="img cycling-plus">
        <img
          src="~/assets/images/trust-marker-logos/cycling-plus.png"
          alt="plus image"
          width="300"
          height="60"
        />
      </div>
      <div class="img ribble">
        <img
          src="~/assets/images/trust-marker-logos/ribble.png"
          alt="plus image"
          width="300"
          height="60"
        />
      </div>
      <div class="img bike-radar">
        <img
          src="~/assets/images/trust-marker-logos/bike-radar.png"
          alt="radar image"
          width="300"
          height="60"
        />
      </div>
      <div class="img sigma">
        <img
          src="~/assets/images/trust-marker-logos/sigma.png"
          alt="sigma image"
          width="100"
          height="27"
        />
      </div>
      <div class="img the-times">
        <img
          src="~/assets/images/trust-marker-logos/the-times.png"
          alt="times image"
          width="300"
          height="60"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.featured {
  margin: 20px 0 25px 0;
  @include tablet {
    margin: 0px 0 25px 0;
  }
}
.subtitle {
  text-align: center;
}
.img-container {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  align-content: flex-end;
  // Without this, flexbox's default align-items:stretch makes every logo in
  // a wrapped row as tall as that row's tallest logo (sigma's is a different
  // source aspect ratio), and object-fit isn't set on these <img> — so the
  // shorter logos in that row get visibly stretched. Logos sit at their own
  // natural height instead.
  align-items: flex-start;
  .img {
    text-align: center;
    display: flex;
    justify-content: center;
    img {
      width: 100%;
      max-width: 85px;
      @include tablet {
        max-width: 150px;
      }
    }
    &.sigma {
      margin: 0 10px;
      // height: 25px;
    }
    // background-size: contain;
    // background-repeat: no-repeat;
    // &.rouler{
    //   background-image: url("~assets/images/trust-marker-logos/the-times.png?size=100");
    // }
    // &.cycling-weekly{
    //   background-image: url("~assets/images/trust-marker-logos/cycling-weekly.png?size=100");
    // }
    // &.cycling-plus{
    //   background-image: url("~assets/images/trust-marker-logos/cycling-plus.png?size=100");
    // }
    // &.bike-radar{
    //   background-image: url("~assets/images/trust-marker-logos/bike-radar.png?size=100");
    // }
    // &.evening-standard{
    //   background-image: url("~assets/images/trust-marker-logos/evening-standard.png?size=100");
    // }
    // &.the-times{
    //   background-image: url("~assets/images/trust-marker-logos/the-times.png?size=100");
    // }
  }
}
</style>
